import React from 'react'
import styled from 'styled-components';
import tw from 'twin.macro'
import { Container, Section } from '../../styles/common/Layout';
import { H1, P } from '../../styles/common/Typo';
import Form from '../feature/contact/Form';
import { LocaleContext } from '../layout/layout';

export default function ContactSection() {
  const lang = React.useContext(LocaleContext)
  const i18n = lang.i18n[lang.locale]
  return (
    <>
      <Section id="section__contact">
        <Container>
          <H1>{i18n.contactForm.headline}</H1>
          <Form />
          <P className="opacity-50" dangerouslySetInnerHTML={{ __html: i18n.contactForm.dataStorageHint }} />
        </Container>
      </Section>
    </>
  )
}
